import api from "./api";

export interface Pagination {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  from: number | null;
  to: number | null;
}

export interface Notification {
  id: string | number;
  type: string;
  data: {
    type: string;
    title: string;
    message: string;
    data?: any;
  };
  read_at: string | null;
  created_at: string;
  created_at_human: string;
}

export interface NotificationResponse {
  success: boolean;
  data: {
    notifications: Notification[];
    pagination: Pagination;
  };
}

export const getNotifications = async (
  page: number = 1,
  perPage: number = 15,
  type: string = "all"
): Promise<NotificationResponse> => {
  try {
    const response = await api.get(`/admin/notifications`, {
      params: {
        page,
        per_page: perPage,
        type,
      },
      headers: {
        Accept: "application/json",
      },
    });

    return response.data as NotificationResponse;
  } catch (err: any) {
    if (!err.response) {
      throw {
        type: "network",
        message: "Network error. Please check your internet connection.",
      };
    }

    throw {
      type: "server",
      message: err.response?.data?.message || err.message,
    };
  }
};

export interface UnreadCountResponse {
  success: boolean;
  data: {
    unread_count: number;
  };
}

export const getUnreadCount = async (): Promise<UnreadCountResponse> => {
  try {
    const response = await api.get(`/admin/notifications/unread-count`, {
      headers: {
        Accept: "application/json",
      },
    });

    return response.data as UnreadCountResponse;
  } catch (err: any) {
    if (!err.response) {
      throw {
        type: "network",
        message: "Network error. Please check your internet connection.",
      };
    }

    throw {
      type: "server",
      message: err.response?.data?.message || err.message,
    };
  }
};

export const markAsRead = async (id: string | number): Promise<{ success: boolean }> => {
  try {
    const response = await api.post(`/admin/notifications/${id}/mark-as-read`, {}, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export const markAllAsRead = async (): Promise<{ success: boolean }> => {
  try {
    const response = await api.post(`/admin/notifications/mark-all-as-read`, {}, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export const deleteNotification = async (id: string | number): Promise<{ success: boolean }> => {
  try {
    const response = await api.delete(`/admin/notifications/${id}`, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (err: any) {
    throw err;
  }
};

export const clearAllNotifications = async (): Promise<{ success: boolean }> => {
  try {
    const response = await api.delete(`/admin/notifications`, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (err: any) {
    throw err;
  }
};
